<template>
  <div v-if="visible" class="modal-backdrop" style="position:fixed;top:0;left:0;right:0;bottom:0;z-index:1050;display:flex;align-items:center;justify-content:center;">
    <div class="card" style="width:100%;max-width:600px;">
      <div class="card-body">
        <h5 class="card-title">{{ title }}</h5>
        <p class="card-text" v-if="message">{{ message }}</p>
        <slot></slot>
        <div class="text-right mt-3">
          <button class="btn btn-secondary mr-2" @click="close">Cancel</button>
          <button class="btn btn-primary" @click="confirm" :disabled="busy">{{ confirmText }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: { type: Boolean, default: false },
    title: { type: String, default: 'Confirm' },
    message: { type: String, default: '' },
    confirmText: { type: String, default: 'OK' },
    busy: { type: Boolean, default: false },
  },
  computed: {
    visible: { get() { return this.value }, set(v) { this.$emit('input', v) } }
  },
  methods: {
    close() { this.$emit('cancel'); this.visible = false; },
    confirm() { this.$emit('confirm'); }
  }
};
</script>
